import { useEffect } from "react";

import localStorage from "shared/util/localStorage";
import isRouteMatch from "shared/util/isRouteMatch";
import { ROUTES } from "routers/shared/util/consts";

const SIGNUP_ACTION_RECORDED_KEY = "signup_action_recorded";
const SIGNUP_ROUTES = [
	...ROUTES.Doubletake,
	ROUTES.ProfileMain[0], // Self Profile
];

const ActionSignup = ({ location }) => {
	const hasShown = localStorage.getItem(SIGNUP_ACTION_RECORDED_KEY);
	const shouldShow = !!(
		window.gtag &&
		!hasShown &&
		isRouteMatch(location, SIGNUP_ROUTES) &&
		location.search.includes("onboarding_complete")
	);

	useEffect(() => {
		if (!shouldShow) {
			return;
		}

		localStorage.setItem(SIGNUP_ACTION_RECORDED_KEY, Date.now());
		window.gtag("event", "conversion", { "send_to": "AW-829392633/BiG_CPzvt3oQ-Y2-iwM" });
		window.gtag("event", "conversion", {
			"allow_custom_scripts": true,
			"send_to": "DC-8236637/step20/dcmok0+standard",
		});
	}, [shouldShow]);

	return null;
};

export default ActionSignup;



// WEBPACK FOOTER //
// ./src/routers/shared/components/ActionSignup.jsx